export const esp = {
  buttons: {
    bookTrialClass: "Reservar una clase",
    backHome: "Inicio",
    loginAccount: "Ingresar a tu cuenta",
    bookClass: "Reserva tu clase gratis",
    bookYourClass: "Reserva tu clase",
    registerFor: "Registrate para una clase gratis",
    createAccount: "Crear cuenta",
    verItalki: "Ver mi perfil de italki",
    visitaMiPerfil: "Visita mi perfil de italki",
    perfilItalki: "Perfil de italki",
    mensajeWhatsapp: "Mensaje en WhatsApp",
  },
  nav: {
    howToStart: "¿Cómo comenzar?",
    aboutMe: "Acerca de mí",
  },
  error: "Ups, algo salió mal",
  trialClassForm: {
    title:
      "Comienza tu aventura de aprender español",
    description:
      "Por favor llena el formulario y me pondré en contacto para agendar tu clase muestra.",
    terms:
      "Al crear una cuenta, aceptas nuestros Términos y condiciones . Recibirás correos electrónicos y notificaciones de Spanish with Monse  sobre el progreso de tu aprendizaje y sobre nuestros servicios. Puedes darte de baja en cualquier momento de forma gratuita. Procesaremos tus datos personales de acuerdo con nuestra Política de privacidad.",
  },
  thanks: {
    title: "¡Gracias por registrarte!",
    info: "En breves me pondré en contacto contigo para agendar tu clase muestra.",
    back: "Regresar al inicio"
  },
  form: {
    name: "Nombre:",
    namePlaceholder: "*Nombre",
    errorName: {
      addName: "Por favor ingresa tu nombre",
      noNumbers: "Por favor no uses números"
    },
    email: "Email:",
    emailPlaceholder: "*Email",
    addEmail: "Por favor ingresa tu email",
    addValidEmail: "Por favor ingresa un email válido",
    password: "Contraseña:",
    passwordPlaceholder: "*Contraseña",
    addPassword: "Por favor ingresa tu contraseña",
    useSixCharacters: "Usa al menos 6 caracteres",
    oneNumber: "Usa al menos un número",
    goal: "Selecciona tu objetivo:",
    addGoal: "Por favor selecciona tu objetivo",
    beginner: "Principiante",
    conversation: "Conversación",
    nextLevel: "Siguiente Nivel",
    errorRegister: "Algo salió mal. Por favor, revisa tu información.",
    errorLogin: "La dirección de email o la contraseña que has introducido no es correcta."
  },
  main: {
    hero: {
      title:
        "Habla español con <1>confianza</1> desde tu primera clase",
      description:
        "Clases privadas en línea. Aprende a tu ritmo, sobre los temas que te interesan.",
    },
    benefits: {
      title:
        "Disfruta de los <1>beneficios</1> de aprender español con clases privadas en línea.",
      Rhythm:
       "Avanza a tu ritmo",
      RhythmText:
       "Tu tiempo, tu agenda, sin presión de seguir a un grupo.",
      Conversations:
       "Temas de tu interés",
      ConversationsText:
       "Conversaciones sobre lo que te importa: viajes, trabajo, familia, lo que sea.",
      Place:
       "Dónde sea",
      PlaceText:
       "Desde cualquier lugar del mundo, con solo una conexión a internet.",
      Plan:
       "Define tus objetivos",
      PlanText:
       "Un plan hecho para ti, no un programa genérico.",
      Topics:
       "Temas de tu interés",
      TopicsText:
        "Aprende con temas que ya te gustan. El idioma se vuelve el medio, no el obstáculo.",
      Questions:
       "Resuelve tus dudas",
      QuestionsText:
       'Puedes preguntar lo que sea, sin sentirte "el que no entendió".',
    },
    goals: {
      title:
        "Clases totalmente enfocadas en alcanzar tus <1>objetivos</1>",
      subtitle:
        "¿Cuál es el tuyo?",
      beginner:
        "Aprende a comunicarte en español desde cero, de forma práctica y sin abrumarte. Empezamos por lo que necesitas decir hoy.",
      perfectForYou:
        "Ideal para ti",
      beginnerList:
        `<1>Es tu primera vez intentando aprender español.</1>
        <1>Entiendes un poco, pero no conoces la gramática.<1/>`,
      conversation:
        "Ya entiendes algo de español, pero cuando quieres hablar, las palabras no salen. Trabajamos exactamente eso: que puedas expresarte con soltura en situaciones reales.",
      conversationList:
        `<1>Tienes las bases, pero te cuesta comunicarte.</1>\
        <1>Te cuesta expresar tus ideas con fluidez.</1>\
        <1>Quieres practicar temas de la vida cotidiana.</1>`,
      nextLevel:
        'Tu español funciona, pero quieres más: mejor pronunciación, textos más complejos, vocabulario especializado. Definimos juntos qué significa "el siguiente nivel" para ti.',
      nextLevelList:
        `<1>Ya te comunicas bien, pero quieres sonar más natural.</1>\
        <1>Quieres hablar de temas especializados o técnicos.</1>\
        <1>Buscas mejorar pronunciación, redacción o comprensión.</1>`,
    },
    banner1: {
      title:
        "¿Todavía tienes dudas?",
      content:
        "Empieza con una clase gratis. Sin formularios largos, sin tarjeta de crédito. Solo 30 minutos para que veas de qué va esto.",
    },
    banner2: {
      title:
        "¿Todavía tienes dudas?",
      content:
        "Totalmente normal. La primera clase es gratis para que veas cómo trabajamos y decidas cuando estés listo.",
    },
    trustBar: {
      title: "Más de 8 años enseñando español a estudiantes de todo el mundo",
      1: "+5,000",
      label1: "clases impartidas en línea",
      2: "+1,800",
      label2: "clases impartidas en italki",
      3: "5.0",
      label3: "calificación en italki",
      button: "Ver reseñas en italki",
    },
    howToStart: {
      title: "Empezar es más <1>fácil</1> de lo que crees. Solo tres pasos:",
      1: "Dime qué quieres lograr",
      2: "Reserva tu clase muestra",
      3: "Elige el plan de clases que prefieras",
    },
    aboutMe: {
      title:
       "¡Hola! mi nombre es Monserrat, pero puedes decirme Monse.",
      intro:
       "Soy maestra de español, mexicana, y alguien que alguna vez estuvo varada en un barco en el Caribe con 300 personas de más de 60 países, sin internet. De esa experiencia aprendí que conectar con alguien en su idioma vale más que cualquier certificado.",
      content:
        "Llevo más de 8 años enseñando español online, adaptando cada clase a la persona que tengo enfrente: su ritmo, sus metas, su forma de aprender. Si no sabes por dónde empezar, no te preocupes, juntos encontramos el camino.",
      visitProfile: "Visita mi perfil de italki",
      messageWhatsapp: "Mensaje en WhatsApp",
    },
    testimonials: {
      title: "Lo que dicen mis <1>estudiantes</1>",
      calltoaction: "Ver más reseñas de otros estudiantes.",
      testimonial1: {
        name: "Audrey",
        country: "Estados Unidos",
        comment: "Lo diré de nuevo: ¡Monse es una profesora increíble! He estado tomando clases con ella durante tres años (!!!) y puedo decir con confianza que es paciente, amable, divertida y totalmente dedicada al éxito de sus estudiantes. Personaliza cada clase, aún soporta mis malos chistes (pero han mejorado, al igual que mi español) y continúa ayudándome a entender el razonamiento detrás de los nuevos conceptos. Es excepcionalmente organizada y viene preparada cada vez, pero se adapta fácilmente cuando tengo preguntas o necesito ayuda adicional. Su apoyo es genuino, ¡y estoy muy agradecida de haber tenido la suerte de encontrar una profesora que ahora también llamo amiga!",
      },
      testimonial2: {
        name: "Elaine",
        country: "Hong Kong",
        comment: "Como profesora de idiomas, sé exactamente lo difícil que puede ser hacer que una lección sea tanto divertida como útil para los estudiantes. Monse es muy paciente y motivadora, y aporta mucha energía positiva a nuestras clases. Al principio, no me sentía muy cómoda hablando español, pero en sus lecciones siempre me encuentro diciendo más, y ella usa constantemente el español para hacer la clase más inmersiva. ¡Realmente aprecio su estilo de enseñanza y definitivamente la recomiendo a otros estudiantes!",
      },
      testimonial3: {
        name: "Alexander",
        country: "Alemania",
        comment: "Monse es una profesora excelente. Ella siempre me anima a hablar mucho durante la clase, corrige mis errores con paciencia, lo que ayuda mucho a mejorar mi español. Además, las lecciones están muy bien estructuradas y las tareas opcionales me ayudan a profundizar en lo que he aprendido. ¡Ella ha sido un gran apoyo para mí!",
      },
      testimonial4: {
        name: "Lauren",
        country: "Estados Unidos",
        comment: "¡Las clases con Monse siempre son tan divertidas! Cuando tengo un mal día, nuestra clase siempre me saca una sonrisa. Cuando estás aprendiendo español, algunos días puedes hablar bien y otros días apenas puedes formar una oración. De cualquier manera, Monse es paciente, alentadora y divertida para hablar.",
      },
    },
  },
};